"use client";

import { c as _c } from "react/compiler-runtime";
import { addBlogToShares } from "@/actions/blog";
import { ShareLinkDialog } from "@/components/dialog/share-link-dialog";
import { FacebookIcon, LinkedInIcon, WhatsAppIcon, XTwitterIcon } from "@/components/fancy/social-icons";
import { PROJECT_URL } from "@/config/project-details";
import { TBlog } from "@/types/types";
import { tryCatch } from "@/utils/validators";
import { Share } from "lucide-react";
import { useState } from "react";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";
import { toast } from "sonner";
type BlogShareSheetProps = {
  blog: TBlog;
};
export default function BlogShareSheet(t0) {
  const $ = _c(30);
  const {
    blog
  } = t0;
  const [, setSharesCount] = useState(blog.blogSharesCount);
  const shareUrl = `${PROJECT_URL}/blog/${blog.slug}`;
  let t1;
  if ($[0] !== blog.blogSharesCount || $[1] !== blog.id) {
    t1 = async function handleShare() {
      setSharesCount(_temp);
      const {
        error
      } = await tryCatch(addBlogToShares(blog.id));
      if (error) {
        setSharesCount(blog.blogSharesCount);
        toast.error(error.message);
        return;
      }
    };
    $[0] = blog.blogSharesCount;
    $[1] = blog.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleShare = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="text-sm font-medium">Share article:</p>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FacebookIcon size={24} className="fill-foreground transition hover:opacity-70" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== handleShare || $[6] !== shareUrl) {
    t4 = <FacebookShareButton url={shareUrl} onShareWindowClose={handleShare}>{t3}</FacebookShareButton>;
    $[5] = handleShare;
    $[6] = shareUrl;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <WhatsAppIcon size={24} className="fill-foreground transition hover:opacity-70" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== handleShare || $[10] !== shareUrl) {
    t6 = <WhatsappShareButton url={shareUrl} onShareWindowClose={handleShare}>{t5}</WhatsappShareButton>;
    $[9] = handleShare;
    $[10] = shareUrl;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <XTwitterIcon size={24} className="fill-foreground transition hover:opacity-70" />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== handleShare || $[14] !== shareUrl) {
    t8 = <TwitterShareButton url={shareUrl} onShareWindowClose={handleShare}>{t7}</TwitterShareButton>;
    $[13] = handleShare;
    $[14] = shareUrl;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <LinkedInIcon size={24} className="fill-foreground transition hover:opacity-70" />;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== handleShare || $[18] !== shareUrl) {
    t10 = <LinkedinShareButton url={shareUrl} onShareWindowClose={handleShare}>{t9}</LinkedinShareButton>;
    $[17] = handleShare;
    $[18] = shareUrl;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = `${PROJECT_URL}/blog/${blog.slug}`;
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Share size={20} className="cursor-pointer transition hover:opacity-70" />;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== handleShare || $[22] !== t11) {
    t13 = <ShareLinkDialog title="Share blog" description="Let others know about this blog!" shareUrl={t11} onShareAction={handleShare}>{t12}</ShareLinkDialog>;
    $[21] = handleShare;
    $[22] = t11;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t10 || $[25] !== t13 || $[26] !== t4 || $[27] !== t6 || $[28] !== t8) {
    t14 = <div className="mx-auto mt-8 flex items-end gap-4">{t2}{t4}{t6}{t8}{t10}{t13}</div>;
    $[24] = t10;
    $[25] = t13;
    $[26] = t4;
    $[27] = t6;
    $[28] = t8;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
}
function _temp(prev) {
  return prev + 1;
}